import { defineStore } from 'pinia';
import CrmDealsAPI from 'dashboard/api/crmDeals';

// As pendências de atividade do usuário logado, como o ícone da barra lateral
// mostra: novas (atribuídas por outra pessoa desde a última vez que o painel
// abriu), atrasadas, de hoje e próximos 7 dias. O servidor separa as seções
// (Crm::TaskPendencies); aqui só se guarda e se pede de novo.
const EMPTY = Object.freeze({
  counts: { new: 0, overdue: 0, today: 0 },
  total: 0,
  new: [],
  overdue: [],
  today: [],
  upcoming: [],
});

export const useCrmTaskPendenciesStore = defineStore('crmTaskPendencies', {
  state: () => ({
    data: { ...EMPTY },
    isOpen: false,
    isLoading: false,
    loadedAt: null,
  }),
  getters: {
    total: state => state.data.total || 0,
    badge: state => {
      const total = state.data.total || 0;
      if (!total) return '';
      return total < 100 ? `${total}` : '99+';
    },
  },
  actions: {
    async fetch() {
      this.isLoading = true;
      try {
        const { data } = await CrmDealsAPI.taskPendencies();
        this.data = data;
        this.loadedAt = Date.now();
      } catch {
        // Sem rede o contador fica como está; a próxima leitura corrige.
      } finally {
        this.isLoading = false;
      }
    },
    // Abrir o painel marca as novas como vistas. A lista volta já sem elas na
    // seção "novas", mas com elas nas seções por data.
    async open() {
      this.isOpen = true;
      try {
        const { data } = await CrmDealsAPI.markTaskPendenciesSeen();
        this.data = data;
        this.loadedAt = Date.now();
      } catch {
        await this.fetch();
      }
    },
    close() {
      this.isOpen = false;
    },
    async complete(task) {
      if (task.deal_id) {
        await CrmDealsAPI.updateTask(task.deal_id, task.id, {
          completed_at: new Date().toISOString(),
        });
      } else {
        await CrmDealsAPI.updateStandaloneTask(task.id, { completed: true });
      }
      await this.fetch();
    },
  },
});
